<ul class="list-unstyled">
  @for (item of menuItems(); track $index) {
    <li class="mb-2">
      <a
        [routerLink]="item.route"
        [queryParams]="item.queryParams"
        class="btn btn-link text-secondary fw-bold text-capitalize w-100 text-start p-2"
        [ngClass]="{ 'bg-white shadow': item.isActive }"
      >
        @if (item.isActive) {
          <lib-round-icon class="me-1" classNames="bg-primary text-white">
            <fa-icon [icon]="['fas', item.icon]"></fa-icon>
          </lib-round-icon>
        } @else {
          <lib-rounded-icon class="me-1" classNames="bg-white text-primary shadow">
            <fa-icon [icon]="['fas', item.icon]"></fa-icon>
          </lib-rounded-icon>
        }
        {{ item.label | translate }}
      </a>
    </li>
  }
</ul>
